import React from 'react'
import './CaptionWrapper.css'

interface IProps {
  caption?: string
  figure?: number
  contentPadding: string
  captionPadding: number
  isTable?: boolean
  children?: React.ReactNode
}

function CaptionWrapper (props: IProps) {
  return (
    <div
      className="wrapper-with-caption"
      style={{
        padding: props.contentPadding
      }}
    >
      {props.children}
      <div className="caption" style={{ padding: `${props.captionPadding}px` }}>
        {props.figure && <span>Figure {props.figure}.</span>}
        {props.isTable && <span>Table {props.figure}.</span>}
        {props.caption}
      </div>
    </div>
  )
}

export default CaptionWrapper
